import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { facetGroupToParam } from '@features/product-filter/product-filter.functions';
import { Facet, FacetConfigResponse as FacetGroup } from '@models/api-search.models';
import { fadeTransition } from '@shared/animations/animations';
import { transform } from '@shared/animations/animations.functions';
import { GtmService } from '@core/services/gtm/gtm.service';
import { ReplaceKeyPipe } from '@features/product-filter/pipes/replace-key.pipe';
import { ActiveFacetsCountPipe } from '@features/product-filter/pipes/active-facets-count.pipe';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { FilterCountComponent } from '../filter-count/filter-count.component';
import { NgClass, NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-filter-select',
    templateUrl: './filter-select.component.html',
    styleUrls: ['./filter-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [transform({ property: 'translateY', valueFrom: '10%', valueTo: '0%' }), fadeTransition],
    imports: [NgClass, NgIf, FilterCountComponent, SvgIconComponent, NgFor, FormsModule, TranslateSafePipe, ActiveFacetsCountPipe, ReplaceKeyPipe]
})
export class FilterSelectComponent {
    public expanded: boolean = false;
    public insideClick: boolean = false;

    @Input()
    public readonly facetGroup?: FacetGroup;

    @Output()
    public readonly facetUpdate: EventEmitter<Params> = new EventEmitter();

    @Output()
    public readonly expandUpdate: EventEmitter<boolean> = new EventEmitter();

    constructor(private readonly gtmService: GtmService) {}

    @HostListener('click')
    clickInside(): void {
        this.insideClick = true;
    }

    // Listen for clicks on entire document
    @HostListener('document:click')
    clickOutside(): void {
        if (!this.insideClick) {
            this.expand(false);
        }
        this.insideClick = false;
    }

    // Close if Escape key pressed
    @HostListener('keydown.escape')
    escapeHandler(): void {
        this.expand(false);
    }

    public expand(expanded: boolean): void {
        this.expanded = expanded;
        this.expandUpdate.emit(Boolean(this.expanded));
    }

    public onChange(facet: Facet): void {
        if (this.facetGroup?.key && this.facetGroup?.values?.length) {
            const param = facetGroupToParam(this.facetGroup.key, this.facetGroup.values);
            this.facetUpdate.emit(param);

            if (facet.selected) {
                this.gtmService.trackFilterChanges({ [this.facetGroup.key]: facet.key });
            }
        }
    }

    public trackFacetFn(index: number, facet: Facet): string {
        return facet.key || `facet_${index}`;
    }
}
